module.exports = __webpack_public_path__ + "static/media/DemandListing_Background.e15e3481.webp";